import React from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";

import { HelpPage } from "../pages/help/HelpPage";
import { getEulaHeaderHeight } from "../store/layout";

export const HelpPageRouter = () => {
  const eulaHeaderHeight = useSelector(getEulaHeaderHeight);

  return (
    <Routes>
      <Route index element={<HelpPage eulaHeaderHeight={eulaHeaderHeight} />} />
      <Route
        path=":section"
        element={<HelpPage eulaHeaderHeight={eulaHeaderHeight} />}
      />
    </Routes>
  );
};
